export const formatTableCellContent = (content: React.ReactNode) => {
  if (typeof content === 'string') {
    // 9자리 이하 숫자를 금액으로 변환
    if (/^\d{1,9}$/.test(content)) {
      return `${Number(content).toLocaleString()}`;
    }

    // 날짜 형식 변환
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(content)) {
      const date = new Date(content.replace(' ', 'T'));
      return `${date.getFullYear()}년 ${
        date.getMonth() + 1
      }월 ${date.getDate()}일 ${date.getHours()}시 ${date.getMinutes()}분`;
    }
  }

  return content;
};
